module.exports = __webpack_public_path__ + "img/suika ibuki.6ca99ad4.png";